export default {"src":"/_next/static/media/bulletDet.d497ddbb.svg","height":30,"width":39,"blurWidth":0,"blurHeight":0};